import {useMutation} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api from 'src/services/api'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

type UpdateCameraAdvancedData = {
  cameraId: number
  detectionSensitivity?: number
  largeQueue?: boolean
}

export default function useUpdateAdvancedCamera() {
  const {enqueueSnackbar} = useSnackbar()

  const mutation = useMutation({
    mutationFn: async ({detectionSensitivity, largeQueue, cameraId}: UpdateCameraAdvancedData) => {
      return await api.camera.updateAdvancedConfig({id: cameraId, detectionSensitivity, largeQueue})
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Erro ao atualizar configurações')
    },
    onSuccess: () => {
      enqueueSnackbar('Configurações atualizadas com sucesso', {variant: 'success'})
    },
  })

  return mutation
}
